import { createAction, union } from '@ngrx/store';
import { auth } from 'firebase/app';
import { PhoneNumber } from 'src/app/models/auth/phone-number';

export const storeConfirmationResult = createAction(
  'SignUpActions storeConfirmationResult',
  (payload: auth.ConfirmationResult) => ({ payload }),
);

export const storePhoneNumber = createAction(
  'SignUpActions storePhoneNumber',
  (payload: PhoneNumber) => ({ payload }),
);

export const updateLoading = createAction(
  'SignUpActions updateLoading',
  (payload: boolean) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'SignUpActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const resetState = createAction('SignUpActions resetState');

const all = union({
  storeConfirmationResult,
  storePhoneNumber,
  updateLoading,
  storeErrorMessage,
  resetState,
});
export type SignUpActionsUnion = typeof all;
